import { render } from "./OpeningQuiz.vue?vue&type=template&id=7d17a5c4&scoped=true"
import script from "./OpeningQuiz.vue?vue&type=script&lang=js"
export * from "./OpeningQuiz.vue?vue&type=script&lang=js"

import "./OpeningQuiz.vue?vue&type=style&index=0&id=7d17a5c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d17a5c4"]])

export default __exports__